// extracted by mini-css-extract-plugin
export var deliveryRow = "_r2-a";
export var fixedHeight = "_r2-4";
export var freightLogo = "_r2-9";
export var fullWidth = "_r2-3";
export var priceColumn = "_r2-5";
export var radioSelected = "_r2-7";
export var radioUnselected = "_r2-6";
export var selectedOption = "_r2-2";
export var selectedOptionContainer = "_r2-1";
export var selection = "_r2-0";
export var tallSkeletonText = "_r2-8";